module.exports = __webpack_public_path__ + "static/media/homePagePic.02871baf.png";